// extracted by mini-css-extract-plugin
export default {"wrapper":"a2-z","play":"b2-z"};